import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useGeneralStore } from "%/stores/general-store";

export const useContractFeedStore = defineSmartFeedPiniaStore("contract-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      orgId: useGeneralStore().orgId,
    },
    tableFields: [
      {
        key: "name",
        label: "Name",
      },
      {
        key: "status",
        label: "Status",
      },
      {
        key: "contractorOrgName",
        label: "Contractor",
      },
      {
        key: "contracteeOrgName",
        label: "Contractee",
      },
      {
        key: "timestampCreated",
        label: "Created",
      },
      {
        key: "actions",
        label: "Actions",
      },
    ],
  }),
  getters: {
    feedUrl() {
      return `/contract/${this.metadata.orgId}/contracts`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        contract_status: this.metadata.contractStatus,
      };
    },
  },
});
